import { LatencyTracker, type LatencyKind } from './tracker.ts';

const row = (kind: LatencyKind, label: string): string => `<div><span>${label}</span><b data-latency-${kind}>—</b><small data-count-${kind}>0 samples</small></div>`;

export function mountLatencyHud(host: HTMLElement, tracker: LatencyTracker, clockOffset: () => { offsetMs: number; roundTripMs: number; complete: boolean }): () => void {
  host.innerHTML = `<section class="latency-hud"><div class="latency-title"><p class="eyebrow">MEASURED LIVE</p><span data-clock>clock sync starting</span></div>${row('person', 'Person → FLOOR')}${row('edit', 'Edit → TV paint')}${row('frame', 'FLOOR frame')}</section>`;
  const render = (): void => {
    for (const kind of ['person', 'edit', 'frame'] as const) {
      const summary = tracker.summary(kind);
      const output = host.querySelector<HTMLElement>(`[data-latency-${kind}]`);
      const count = host.querySelector<HTMLElement>(`[data-count-${kind}]`);
      if (output) output.textContent = summary.p50 === undefined ? '—' : `p50 ${summary.p50.toFixed(1)} · p95 ${summary.p95!.toFixed(1)} ms`;
      if (count) count.textContent = `${summary.count} sample${summary.count === 1 ? '' : 's'}`;
    }
    const clock = clockOffset();
    const clockElement = host.querySelector<HTMLElement>('[data-clock]');
    if (clockElement) clockElement.textContent = clock.complete
      ? `clock ${clock.offsetMs >= 0 ? '+' : ''}${clock.offsetMs.toFixed(1)} ms · RTT ${clock.roundTripMs.toFixed(1)} ms`
      : 'clock sync: best of 8 pings';
  };
  const timer = window.setInterval(render, 500);
  render();
  return () => clearInterval(timer);
}
